import { CheckUserExistsResult } from '../../models';

export class ResetUserExistenceCheck {
  static readonly type = '[Member] Reset User Existence Check';
}

export class CheckUserExistsByEmail {
  static readonly type = '[Member] Check User Exists By Email';

  constructor(
    public email: string,
    public selectedCompanyId: string | null,
  ) {}
}

export class CheckUserExistsByEmailSuccess {
  static readonly type = '[Member] Check User Exists By Email Success';

  constructor(public isUserExists: CheckUserExistsResult) {}
}

export class CheckUserExistsByEmailFail {
  static readonly type = '[Member] Check User Exists By Email Fail';

  constructor(public error: any) {}
}
